<template>
    <div>
        <div>
            <SignInPC v-if="isPC" />
            <SignInH5 v-else />
        </div>
    </div>
</template>
<script>
    import { enableAppShare } from '../../../common/js/APP/share';
    import SignInH5 from '../components/SignInH5';
    import SignInPC from '../components/SignInPC';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC,
        },
        data() {
            return {
                isBView:'',//A版 false     B版 true
            };
        },
        created () {
            enableAppShare({
                title: '大厂内推直播专场',
                desc: '拉勾极速内推，直达业务负责人，今天投递，明天拿offer！',
                imgUrl: 'https://s20.lgstatic.com/growth/activity/20220215/1644912610561.png'
            });
        },
        methods: {

        },
    };
</script>